import dynamic from "next/dynamic";

const sectionComponents = {
  // convert:         dynamic(() => import("./_sections/Convert").then((mod)         => mod.Convert)),
  feature: dynamic(() =>
    import("./_sections/Feature").then((mod) => mod.Feature),
  ),
  testimonial: dynamic(() =>
    import("./_sections/Testimonial").then((mod) => mod.Testimonial),
  ),
  app_download: dynamic(() =>
    import("./_sections/AppDownload").then((mod) => mod.AppDownload),
  ),
  // best_solutions: dynamic(() =>
  //   import("./_sections/BestSolutions").then((mod) => mod.BestSolutions),
  // ),
  // brand: dynamic(() => import("./_sections/Brand").then((mod) => mod.Brand)),
  country: dynamic(() =>
    import("./_sections/Country").then((mod) => mod.Country),
  ),
  // many_more: dynamic(() =>
  //   import("./_sections/ManyMore").then((mod) => mod.ManyMore),
  // ),
  text_slider: dynamic(() =>
    import("./_sections/TextSlider").then((mod) => mod.TextSlider),
  ),

  // About Sections
  mission_vision: dynamic(() =>
    import("./_sections/MissionVision").then((mod) => mod.MissionVision),
  ),
  timeline: dynamic(() =>
    import("./_sections/TimelineSection").then((mod) => mod.TimelineSection),
  ),
  our_team: dynamic(() =>
    import("./_sections/TeamSection").then((mod) => mod.TeamSection),
  ),
  our_partners: dynamic(() =>
    import("./_sections/OurPartner").then((mod) => mod.default || mod.OurPartner),
  ),
  about_item: dynamic(() =>
    import("./_sections/AboutItemSection").then((mod) => mod.AboutItemSection),
  ),

  // Wallet Sections
  wallet_banner: dynamic(() =>
    import("./_sections/WalletBannerSection").then(
      (mod) => mod.WalletBannerSection,
    ),
  ),
  wallet_items: dynamic(() =>
    import("./_sections/WalletItemsSection").then(
      (mod) => mod.WalletItemsSection,
    ),
  ),
  wallet_reviews: dynamic(() =>
    import("./_sections/WalletReviewsSection").then(
      (mod) => mod.WalletReviewsSection,
    ),
  ),
};

export const RenderSections = ({ page, sections = [] }) => {
  return (
    <>
      {sections?.map((section, index) => {
        const DynamicComponent = sectionComponents[section];
        return DynamicComponent ? (
          <DynamicComponent key={index} section={section} />
        ) : null;
      })}
    </>
  );
};
